/* unplugin-vue-components disabled */import { render } from "./Question.vue?vue&type=template&id=1e9a10b6&scoped=true"
import script from "./Question.vue?vue&type=script&lang=js"
export * from "./Question.vue?vue&type=script&lang=js"

import "./Question.vue?vue&type=style&index=0&id=1e9a10b6&lang=scss&scoped=true"

import exportComponent from "../../../../../../../common/temp/node_modules/.pnpm/vue-loader@17.2.2_3tnefydtqxjg44ddub7xm4i2wi/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e9a10b6"]])

export default __exports__